/**
 * EnergyConnect.WebApi | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const Quadrant = {
    NotSpecified: 'NotSpecified',
    Consumption: 'Consumption',
    Production: 'Production',
    ReactivePositive: 'ReactivePositive',
    ReactiveNegative: 'ReactiveNegative',
} as const;
export type Quadrant = typeof Quadrant[keyof typeof Quadrant];

